
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Language from '@/components/Menu/components/language/language.vue'

@Component({
    components: { Language },
})
export default class AnonumousProjectIndex extends Vue {
    get projectId() {
        return this.$route.params.id
    }

    get isExactRoute() {
        // Check if the current route is exactly the parent route and not a child route
        return this.$route.matched.length === 1 && this.$route.path.includes(this.projectId)
    }
}
